export default __webpack_public_path__ + "static/media/rentals-for-larger groups.cf24ebfe.jpeg";